import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { IfcFile, IfcParseError } from 'situview-webapi-client';

@Component({
  selector: 'ifc-file-list',
  templateUrl: './ifc-file-list.component.html',
  styleUrls: ['./ifc-file-list.component.less']
})
export class IfcFileListComponent implements OnInit {

  @Input() companyId: string | undefined;
  @Input() loading: boolean = false;
  @Input() homeIfcFiles: IfcFile[] | undefined;
  @Input() homeIfcFileErrors: IfcParseError[] | undefined;
  @Input() emitSelection: boolean = false;
  @Output() ifcFileSelection: EventEmitter<IIfcFileQuery> = new EventEmitter();

  isNotErrorFeed: boolean = true;

  constructor(
    private router: Router
  ) { }

  ngOnInit(): void {}

  capitalizeFirstLetter(text: string) {
    if (text) {
      return `${text.charAt(0).toUpperCase()}${text.slice(1)}`;
    }
    return "";
  };

  navigateToIfc(home: string, ifcFile: string, version: string, errors: boolean = false) {
    if (errors) {
      if (this.emitSelection) {
        this.ifcFileSelection.emit({ "file": ifcFile, "version": version, "tab": "errors" } as IIfcFileQuery);
      } else {
        this.router.navigate(['/homes', home], { queryParams: { ifcFile: ifcFile, v: version, tab: "errors" } });
      }
    } else {
      if (this.emitSelection) {
        this.ifcFileSelection.emit({ "file": ifcFile, "version": version, "tab": "products" } as IIfcFileQuery);
      } else {
        this.router.navigate(['/homes', home], { queryParams: { ifcFile: ifcFile, v: version, tab: "products" } });
      }
    }
  };

  viewFullReport() {
    this.router.navigate(['/reports/ifc-report']);
  };
  
  toggleErrorIfcFeed() {
    this.isNotErrorFeed = !this.isNotErrorFeed;
  };

  isRecent(uploadTime: Date) {
    let date = new Date();
    date.setHours(date.getHours() - 1);
    return uploadTime > date; 
  }
}

export interface IIfcFileQuery {
  file: string;
  version: string;
  tab: string;
}